<template>
  <div id="app">
    <component :is="this.$route.meta.layout || 'div'">
      <router-view />
    </component>
  </div>
</template>

<script>
import Vue from "vue";

export default {
    name: "App",

    mounted() {
        this.$backend.getOrganizace(response => Vue.prototype.$nazevObce = (response.data != null) ? response.data.nazevObce : null );
    }
};

</script>

<style  lang="scss">

// Import custom SASS variable overrides
@import './assets/scss/alis-poweb.scss';

:root{
  --gov-color-success: #{$gov-color-success};
  --gov-color-error: #{$gov-color-error};
  --gov-color-error-400: #{$gov-color-error-400};
  --gov-form-input-border-secondary: #{$gov-form-input-border-secondary};
  --gov-color-neutral-white: #{$gov-color-neutral-white};
  --gov-color-primary: #{$gov-color-primary};
  --gov-color-primary-100: #{$gov-color-primary-100};
  --gov-color-primary-200: #{$gov-color-primary-200};
  --gov-color-secondary-300: #{$gov-color-secondary-300};
  --gov-color-secondary-100: #{$gov-color-secondary-100};
  --gov-color-secondary-500: #{$gov-color-secondary-500};
  --gov-color-secondary-600: #{$gov-color-secondary-600};
  --gov-color-secondary-700: #{$gov-color-secondary-700};
  --gov-color-secondary-800: #{$gov-color-secondary-800};
  --gov-form-label-color: #{$gov-form-label-color};
  --gov-attachments-decor-color: #{$gov-attachments-decor-color};

  --gov-text-xs-font-weight: #{$gov-text-xs-font-weight};
  --gov-text-xs-font-size: #{$gov-text-xs-font-size};
  --gov-text-xs-line-height: #{$gov-text-xs-line-height};
  --gov-text-xs-letter-spacing: #{$gov-text-xs-letter-spacing};

  --gov-text-s-font-weight: #{$gov-text-s-font-weight};
  --gov-text-s-font-size: #{$gov-text-s-font-size};
  --gov-text-s-line-height: #{$gov-text-s-line-height};
  --gov-text-s-letter-spacing: #{$gov-text-s-letter-spacing};

  --gov-text-xl-font-weight: #{$gov-text-xl-font-weight};
  --gov-text-xl-font-size: #{$gov-text-xl-font-size};
  --gov-text-xl-line-height: #{$gov-text-xl-line-height};
  --gov-text-xl-letter-spacing: #{$gov-text-xl-letter-spacing};
}

</style>
